import React from "react";

export const RedStatusDotIcon: React.FC<React.ComponentProps<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <circle cx="8" cy="8" r="6" fill="#991b1b" fillOpacity="0.16" />
    <circle cx="8" cy="8" r="3.5" fill="#ef4444" />
  </svg>
);
